import React from 'react';
import { useCart } from '../../contexts/CartContext';
import { useSettings } from '../../contexts/SettingsContext';
import { useAuth } from '../../contexts/AuthContext';

const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  const { settings } = useSettings();
  const { user, isAuthenticated } = useAuth();
  const exchangeRate = settings?.exchange_rate || 40;

  const isWholesale = isAuthenticated && (
    user?.role === 'cliente_mayorista' || 
    user?.is_wholesale === 1 ||
    user?.is_wholesale === true
  );

  const priceDetail = Number(product.price_usd) || 0;
  const priceWholesale = Number(product.price_wholesale_usd) || 0;
  const hasWholesalePrice = priceWholesale > 0;
  const minWholesaleQty = product.min_wholesale_qty || 1;
  const unitsPerPackage = product.units_per_package || 1;
  const isPackage = unitsPerPackage > 1;

  const handleAdd = () => {
    addItem({
      id: product.id,
      name: product.name,
      price: priceDetail,
      priceWholesale: hasWholesalePrice ? priceWholesale : null,
      minWholesaleQty: minWholesaleQty,
      icon: product.icon || '🍞',
      unitsPerPackage: unitsPerPackage,
      isWholesale: isWholesale
    });
  };

  return (
    <div className="bg-white rounded-2xl p-4 md:p-6 text-center transition border border-primary/5 shadow-sm hover:shadow-md hover:-translate-y-1.5 hover:border-gold/20 cursor-pointer relative">
      {isWholesale && product.wholesale_only && (
        <div className="absolute top-3 right-3 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md">
          🏪 Solo Mayorista
        </div>
      )}

      <span className="text-4xl md:text-5xl block mb-2">{product.icon || '🍞'}</span>
      
      {product.badge && (
        <span className="inline-block text-xs font-bold text-gold uppercase tracking-wide px-3 py-0.5 bg-gold/10 rounded-full mb-2">
          {product.badge}
        </span>
      )}
      
      <h4 className="font-serif text-lg md:text-xl text-primary mb-1">{product.name}</h4>
      <p className="text-text-secondary text-sm font-light leading-relaxed line-clamp-2">
        {product.description}
      </p>

      {/* Info de paquete */}
      {isPackage && (
        <div className="mt-2 inline-block bg-blue-50 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full">
          📦 Contiene {unitsPerPackage} unidades
        </div>
      )}

      {/* Precios */}
      <div className="my-3 md:my-4">
        <div className="text-xl md:text-2xl font-bold text-gold">
          ${priceDetail.toFixed(2)}
          {isPackage && (
            <span className="text-xs text-gray-500 font-normal ml-1">
              /bandeja
            </span>
          )}
          <span className="block text-xs text-text-light font-normal">
            Bs {(priceDetail * exchangeRate).toFixed(2)}
          </span>
        </div>

        {isPackage && (
          <div className="text-xs text-gray-500 mt-1">
            ${(priceDetail / unitsPerPackage).toFixed(2)} por unidad
          </div>
        )}

        {isWholesale && hasWholesalePrice && (
          <div className="mt-2 pt-2 border-t border-dashed border-green-200">
            <div className="text-xs text-green-600 font-semibold uppercase tracking-wide mb-1">
              🏪 Precio al mayor
            </div>
            <div className="text-lg font-bold text-green-600">
              ${priceWholesale.toFixed(2)}
              <span className="block text-xs text-green-500 font-normal">
                Bs {(priceWholesale * exchangeRate).toFixed(2)}
              </span>
            </div>
            {minWholesaleQty > 1 && (
              <div className="text-xs text-green-700 mt-1">
                Desde {minWholesaleQty} unidades
              </div>
            )}
          </div>
        )}
      </div>

      <button
        onClick={handleAdd}
        className="bg-primary text-white border-none px-6 py-2 rounded-full font-medium text-sm hover:bg-gold hover:scale-105 transition min-h-[44px] min-w-[120px]"
      >
        Añadir
      </button>

      {!isWholesale && hasWholesalePrice && !product.wholesale_only && (
        <div className="mt-3 pt-3 border-t border-gray-100">
          <p className="text-xs text-gray-400">
            💼 ¿Compras al mayor? <br />
            <a href="/register" className="text-gold hover:underline font-medium">
              Solicita tu cuenta mayorista
            </a>
          </p>
        </div>
      )}
    </div>
  );
};

export default ProductCard;
